<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h5><span class="text-red">＊</span> 此區可新增、編輯品牌下所有菜單的內容</h5>
            <h5><span class="text-red">＊</span> 如需建立某張菜單，請至菜單管理</h5>
          </div>
          <div class="box-body">
            <brand-table />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import brandTableTemp from '../Brand/Temp/BrandTableTemp.vue'
import config from '@/assets/js/handle-config.js'
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  name: 'MenuDetailTable',
  data () {
    return {
      tableIndex: 1
    }
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    }
  },
  components: {
    'brand-table': brandTableTemp
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    }
  },
  beforeRouteEnter (to, from, next) {
    var url = 'brand/list?page=1&size=10'
    var roleType = window.localStorage.getItem('Nidin_wb_role_type')
    var token = window.localStorage.getItem('Nidin_wb_token')
    if (roleType === '30') {
      axios({
        baseURL: config.baseURL,
        method: 'get',
        url: url,
        headers: {
          'MC-API-Token': token
        }
      })
      .then(function (response) {
        if (response.data.list.length === 1) {
          var branId = response.data.list[0].id
          next('/brandMenu/' + branId)
        } else next()
      })
    } else next()
  }
}
</script>



// WEBPACK FOOTER //
// MenuDetailTable.vue?76cd8c07